module.exports = require("/Users/jxie/projects/lyra/packages/web/.gatsby/gatsby-browser.tsx");